import React, { useState } from 'react';

const BoxHandler = ({ options, children, titleRight }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  // 선택된 옵션 변경 핸들러
  const handleOptionClick = (index) => {
    setSelectedIndex(index);
  };

  // children을 배열로 변환하여 현재 선택된 콘텐츠만 표시
  const renderContent = () => {
    const contentArray = React.Children.toArray(children);
    return contentArray[selectedIndex] || null;
  };

  return (
    <>
      <div className="wa-card-title">
        {options.title}
        <div className="wa-selectable">
          {options.tabs.map((option, index) => (
            <div
              key={index}
              className={`wa-selectable-op ${index === selectedIndex ? 'selected' : ''}`}
              onClick={() => handleOptionClick(index)}
            >
              {option}
            </div>
          ))}
        </div>
        {titleRight}
      </div>
      {renderContent()}
    </>
  );
};

export default BoxHandler;